import React from "react";

function ManageAccount() {
  return <div>ManageAccount</div>;
}

export default ManageAccount;
